import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@travelata-libs/ui-kit';
import { pluralize } from '@travelata-libs/utils'
import { ref, computed } from 'vue';
import { Rating, Progress } from '@travelata-libs/ui-shared';
import getHotelReviews from '../api/getHotelReviews';
import { type HotelReview, type InfoRating, type HotelReviewsResult } from '../api/types';
import { MAX_SIZE_REVIEWS } from '../config';
import HotelReviewCard from './HotelReviewCard.vue';

interface HotelReviewsProps {
    hotelId: number;
    initialHotelReview: HotelReviewsResult['result'] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HotelReviews',
  props: {
    hotelId: null,
    initialHotelReview: null
  },
  setup(__props: any) {

const props = __props as {
    hotelId: number;
    initialHotelReview: HotelReviewsResult['result'] | null;
};



const reviews = ref<HotelReview[]>(props.initialHotelReview?.reviews || []);
const reviewsCount = ref(props.initialHotelReview?.count || 0);
const rate = ref(props.initialHotelReview?.rate || 0);
const infoRatings = ref<InfoRating[]>(props.initialHotelReview?.infoRatings || []);
const page = ref(1);
const filteredInfoRatings = computed(() => infoRatings.value.filter((infoRating) => !!infoRating.rate));

const paginationReviews = computed(() => {
    return reviews.value.filter((review, index) => {
        return index < page.value * MAX_SIZE_REVIEWS;
    } );
});

const buttonText = computed(() => {
    const currentCount = page.value * MAX_SIZE_REVIEWS;

    const nextCount = reviews.value.length - currentCount;

    if(nextCount < 1) return '';

    return `Показать еще ${pluralize(['отзыв', 'отзыва', 'отзывов'], nextCount)}`;
});

const getReviews = async () => {
    const res = await getHotelReviews({ limit: MAX_SIZE_REVIEWS * 2, hotelId: props.hotelId, page: page.value });
    reviews.value.push(...res.reviews);   
};

const showMoreReviews = () => {
    page.value++;
    getReviews();
};

const getLastHotelId = (reviews: HotelReview[]) => {
    return reviews.at(-1)?.id || '';
}


return { __sfc: true,props, reviews, reviewsCount, rate, infoRatings, page, filteredInfoRatings, paginationReviews, buttonText, getReviews, showMoreReviews, getLastHotelId, Button, Rating, Progress, HotelReviewCard }
}

})